module.exports = __webpack_public_path__ + "static/media/hamsa.b377df39.svg";